<template>
  <ErrorBoundary>
    <label class="text-sm font-medium block mt-2">
      {{ $t('product.show.checkout.selectDate') }}
    </label>
    <div class="mt-2 flex flex-col gap-1">
      <button
        v-for="date in availableDates?.slice(0, 4)"
        :key="date.id"
        type="button"
        class="p-3 rounded-lg border text-left transition-colors text-sm text-stone-700"
        :class="{
          'border-teal-600 bg-teal-50 text-teal-700':
            selectedDate?.id === date.id,
          'border-gray-200 hover:border-gray-300': selectedDate?.id !== date.id,
        }"
        @click="handleDateSelect(date)"
      >
        <EventBuyBoxDateOption
          :option-data="date"
          :always-show-multidate="true"
          :show-collapse-button="false"
        />
      </button>
    </div>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import type { EventDate } from '~/composables/types/event'
import {
  pickPreferredOrFirstAvailableDate,
  usePreferredDateIdFromQuery,
} from '~/composables/usePreferredDateIdFromQuery'

const { eventId } = defineProps<{ eventId: string }>()
const selectedDate = ref<EventDate | undefined>(undefined)
const preferredDateId = usePreferredDateIdFromQuery()

const { accumulatedDates: dates } = await useFetchEventDates(eventId, {
  accumulateDates: true,
  query: {
    include: ['children'],
  },
})

const emit = defineEmits(['update-selected-date'])

const availableDates = computed(() => {
  return (
    dates.value?.filter(
      (date: EventDate) =>
        eventDateGetters.getDateIsOpen(date) &&
        eventDateGetters.getAvailableTicketsQuantity(date) > 0
    ) || []
  )
})

const handleDateSelect = (date: EventDate) => {
  selectedDate.value = date
  emit('update-selected-date', date)
}

onMounted(() => {
  const dateToSelect = pickPreferredOrFirstAvailableDate(
    availableDates.value || [],
    preferredDateId.value
  )

  if (dateToSelect) {
    selectedDate.value = dateToSelect
    emit('update-selected-date', dateToSelect)
  }
})
</script>
